import React from 'react';

import CrossIcon from 'icons/ic-close.svg';
import { useTranslation } from 'react-i18next';

import Toast from 'components/application/Toast';

export default function InedibleToast({ fullMessage, onBurnToast, toastKey }) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <Toast
      burn={onBurnToast}
      contents={
        <>
          <div className='toast__icon tw-bg-red-600'>
            <CrossIcon
              className='[&_polygon]:tw-fill-white'
              height={20}
              width={20}
            />
          </div>
          <div className='toast__text'>
            {fullMessage || i18nTShared('errors.generic')}
          </div>
        </>
      }
      modifiers='no-undo'
      toastKey={toastKey}
    />
  );
}

InedibleToast.defaultProps = {
  fullMessage: null,
};
